var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('un-notifications-queue'),_c('routerView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }